<template>
    <div class="storeData">
        <div class="storeData_nap">
            <div class="storeData_napL">统计时间：{{nowDate}}</div>
            <div class="storeData_napR">
                <el-radio-group class="hide_input" v-model="tabPosition">
                    <el-radio-button
                        :label="items.type"
                        v-for="(items, index) in napList"
                        :key="index"
                        @click.native.prevent="selectTimeType(items.type)"
                    >
                        {{ items.name }}
                        <!-- 月 -->
                        <el-date-picker
                            v-show="items.type == 'month'"
                            class="date"
                            @change="dateChangeMonth"
                            v-model="dateDay"
                            type="month"
                            value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                        <!-- 自定义 -->
                        <el-date-picker
                            v-show="items.type == 'day'"
                            class="date"
                            @change="dateRangeChange"
                            v-model="dateDay"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                    </el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div class="storeData_pane">
            <el-tabs tab-position="top" type="card">
                <el-tab-pane label="全部">
                    <transactionAll ref="transactionAllRef" :chartsWidth="chartsWidth"></transactionAll>
                </el-tab-pane>
                <el-tab-pane label="模型订单">
                    <transactionModel ref="transactionModelRef" :chartsWidth="chartsWidth"></transactionModel>
                </el-tab-pane>
                <el-tab-pane label="设计订单">
                    <transactionDesign ref="transactionDesignRef" :chartsWidth="chartsWidth"></transactionDesign>
                </el-tab-pane>
                <el-tab-pane label="打印订单">
                    <transactionPrint ref="transactionPrintRef" :chartsWidth="chartsWidth"></transactionPrint>
                </el-tab-pane>
                <el-tab-pane label="商品订单">
                    <transactionShop ref="transactionShopRef" :chartsWidth="chartsWidth"></transactionShop>
                </el-tab-pane>
                <el-tab-pane label="服务订单">
                    <transactionService ref="transactionServiceRef" :chartsWidth="chartsWidth"></transactionService>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import {getTransactionStatisticData} from "../../utils/interface";

import transactionAll from "./transactionAll";
import transactionModel from "./transactionModel";
import transactionDesign from "./transactionDesign";
import transactionPrint from "./transactionPrint";
import transactionShop from "./transactionShop";
import transactionService from "./transactionService";

import moment from "moment";

export default {
    name: "transactionStatistic",
    components: {
        //所有
        transactionAll,
        //模型订单
        transactionModel,
        //设计订单
        transactionDesign,
        //打印订单
        transactionPrint,
        //商品订单
        transactionShop,
        //服务订单
        transactionService,
    },
    data() {
        return {
            tabPosition: "",
            dateDay: "",
            chartsWidth: "",
            nowDate: moment(new Date()).format("YYYY-MM-DD HH:MM:SS"),
            startTime: "",
            endTime: "",
            timeType:"monthTime",
            loading: false,
            tabPosition: "nowDay",
            napList: [
                {
                    type: "month",
                    name: "月",
                },
                {
                    type: "day",
                    name: "日区间",
                },
            ],
        };
    },
    created() {
        this.chartsWidth = window.innerWidth - 220 + "px";
    },
    mounted() {
        this.init()
    },
    methods: {
        selectTimeType(type) {
            this.tabPosition = type;
        },
        dateChangeMonth(date) {
            console.log(date); //选择的时间
            this.startTime = date;
            this.endTime = date;
            this.timeType = "monthTime";
            let endDate = new Date(this.startTime);
            endDate.setMonth(endDate.getMonth() + 1);
            endDate.setDate(0);
            this.nowDate = this.startTime + ' ~ ' + moment(endDate).format("YYYY-MM-DD")
            this.getList();
        },
        dateRangeChange(date) {
            this.startTime = date[0];
            this.endTime = date[1];
            this.timeType = "autoTime";
            this.nowDate = this.startTime + ' ~ ' + this.endTime
            this.getList();
        },
        init(){
            this.status = null
            this.goodsName = null
            // this.pageNo = 1
            this.getList();
        },
        getList(){
            this.loading = true
            getTransactionStatisticData({timeType: this.timeType,startTime:this.startTime,endTime:this.endTime}).then((res)=>{
                if(res.success){
                    this.$refs.transactionAllRef.init(res.data);
                }
                this.loading = false
            });
            getTransactionStatisticData({timeType: this.timeType,startTime:this.startTime,endTime:this.endTime,moduleType:'PRINT'}).then((res)=>{
                if(res.success){
                    this.$refs.transactionPrintRef.init(res.data);
                }
                this.loading = false
            });
            getTransactionStatisticData({timeType: this.timeType,startTime:this.startTime,endTime:this.endTime,moduleType:'DESIGN'}).then((res)=>{
                if(res.success){
                    this.$refs.transactionDesignRef.init(res.data);
                }
                this.loading = false
            });
            getTransactionStatisticData({timeType: this.timeType,startTime:this.startTime,endTime:this.endTime,moduleType:'SHOP'}).then((res)=>{
                if(res.success){
                    this.$refs.transactionShopRef.init(res.data);
                }
                this.loading = false
            });
            getTransactionStatisticData({timeType: this.timeType,startTime:this.startTime,endTime:this.endTime,moduleType:'MODEL'}).then((res)=>{
                if(res.success){
                    this.$refs.transactionModelRef.init(res.data);
                }
                this.loading = false
            });
            getTransactionStatisticData({timeType: this.timeType,startTime:this.startTime,endTime:this.endTime,moduleType:'SERVICE'}).then((res)=>{
                if(res.success){
                    this.$refs.transactionServiceRef.init(res.data);
                }
                this.loading = false
            });
        }
    },
};
</script>
<style scoped lang="less">
.date{
    width: 100px;
}
.storeData {
    background-color: #ffffff;
    padding: 20px;
    margin: 0 20px;

    .storeData_nap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
    }
}

//隐藏的CSS代码
/*按钮日期选择器隐藏ipnut*/
.hide_input {
    position: relative !important;
}

//修改控件自带的css
.hide_input /deep/ .el-date-editor {
    position: absolute; //绝对定位
    top: 0;
    left: 0;
    opacity: 0; //设置完全透明
}

.hide_input /deep/ .el-input__prefix {
    left: 0;
    width: 55px;
}
</style>



// WEBPACK FOOTER //
// src/views/statistic/transactionStatistic.vue